import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import Button from "@mui/material/Button";
import { useRefresh } from "react-admin";
import { CloseOutlined } from "@mui/icons-material";
import React from "react";
import sendRequest from "../dataProvider/sendRequest";
import CustomButtonSubmit from "../unit/CustomButtonSubmit";
import useNotify from "../unit/useNotify";
import AddIcon from "@mui/icons-material/Add";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/material/styles";
import HmTextInput from "../unit/HmTextInput";
import { useForm, FormProvider } from "react-hook-form";
const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
const RequestdataAdd = (props: any) => {
  const refresh = useRefresh();
  const methods = useForm();
  const id = 99999;
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [open, setOpen] = React.useState(false);
  //filelist save filepath list
  const [filelist, setFilelist] = React.useState<any[]>([]);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    refresh();
  };

  const handleFileChange = async (e) => {
    let file = e.target.files[0];
    let fileAize = file.size / 1024;
    if (fileAize > 1024) {
      errorNotify("File size should be less than 1MB");
      return false;
    }
    let fileNameType = file.name.split(".").pop();
    let fileType = ["pdf", "jpg", "jpeg", "png", "doc", "docx", "xls", "xlsx"];
    if (fileType.indexOf(fileNameType) == -1) {
      errorNotify(
        "File type should be pdf, jpg, jpeg, png, doc, docx, xls, xlsx"
      );
      return false;
    }
    let fileName = file.name;
    if (file) {
      const formData = new FormData();
      formData.append("requestDataUploadFile", file);

      const access_token = localStorage.getItem("access_token");
      const csrfToken = localStorage.getItem("csrfToken");
      fetch(
        `${import.meta.env.VITE_API_URL}/requestdata/actions/uploadFile/0`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${access_token}`,
            "X-CSRF-TOKEN": `${csrfToken}`,
          },
          body: formData,
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data?.code == 200) {
            successNotify("File uploaded successfully");
            setFilelist((prev) => [...prev, data?.file]);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };
  return (
    <>
      <Button
        id="btn-list-add-requestdata"
        onClick={handleOpen}
        variant="text"
        color="primary"
        size="small"
        sx={{
          width: "120px",
          minWidth: "120px",
          color: "primary.main",
          "&.MuiButton-sizeSmall": {
            lineHeight: 1.5,
            fontSize: "0.875rem",
          },
        }}
      >
        <AddIcon sx={{ fontSize: "1.25rem" }} /> Request
      </Button>
      <FormProvider {...methods}>
        <Dialog
          id="dialog-requestdata-add"
          className="request_add_dialog"
          open={open}
          onClose={handleClose}
          fullWidth={true}
          maxWidth="md"
          PaperProps={{
            component: "form",
            // encType: "multipart/form-data",
            onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              let formJson = Object.fromEntries((formData as any).entries());
              //;
              formJson.uploadfile = filelist.join(";");
              const reqUrl = `requestdata/actions/add`;
              const response = await sendRequest(reqUrl, {
                id: "new",
                data: formJson,
              });
              // console.log(response.data);
              if (response && response.code == "200") {
                successNotify("Data saved successfully");
                setFilelist([]);
                refresh();
                handleClose();
              } else {
                errorNotify(response?.message || "Data not saved!");
              }
            },
          }}
        >
          <DialogTitle
            sx={{
              fontWeight: "bold",
              mb: 2,
              borderBottom: "1px solid #e5e5e5",
              color: "#465384",
              textTransform: "uppercase",
            }}
          >
            New Request
            <IconButton
              style={{ position: "absolute", right: "10px", top: "10px" }}
              onClick={handleClose}
            >
              <CloseOutlined />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box
              sx={{
                width: "100%",
                pt: 1,
                height: "50vh",
                maxHeight: "50vh",
              }}
            >
              <HmTextInput
                source="iApplicationId"
                label="Application ID"
                defaultValue={""}
                required={true}
              />
              <HmTextInput
                source="sLoanNum"
                label="Loan Number"
                defaultValue={""}
                required={true}
              />
              <HmTextInput
                source="sDescription"
                label="Description"
                defaultValue={""}
                required={true}
                multiline
                rows={4}
              />

              <>
                {filelist.length > 0 && (
                  <Box>
                    {filelist.map((item) => (
                      <Typography variant="subtitle1" sx={{ mb: 1 }}>
                        Uploaded Files:
                        {item}
                      </Typography>
                    ))}
                  </Box>
                )}
              </>
              <Button
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<CloudUploadIcon />}
                sx={{ width: "100%", maxWidth: "500px", mt: 1 }}
              >
                <VisuallyHiddenInput
                  type="file"
                  id="requestDataUploadFile"
                  name="requestDataUploadFile"
                  onChange={handleFileChange}
                />
              </Button>
            </Box>
          </DialogContent>
          <DialogActions>
            <CustomButtonSubmit label="Add" />
          </DialogActions>
        </Dialog>
      </FormProvider>
    </>
  );
};

export default RequestdataAdd;
